<template>
    <div id="service" class="service" style="margin:15px 15px 30px 15px;font-size: 16px;color: #000000;line-height: 25px;">
        <p style="text-align: center;font-size: 18px;line-height: 40px;">中消在线平台隐私保护政策</p>
        <p>【ZXZX-GF-20190501-002】发布时间：2019/05/01</p>
        <br/>
        <p>重要提示</p>
        <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;为方便用户(以下简称“您”)使用中消在线平台服务，请您在使用服务前仔细阅读以下政策条款。当您申请或使用中消在线平台服务时，即表示您已同意中消在线网按照本政策来合法收集、使用、共享和保护您的个人信息。</p>
        <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;本政策具有合同效力，请您谨慎阅读并遵照执行。</p>
        <br/>1、信息收集
        <br/>&nbsp;&nbsp;&nbsp;1.1 您同意并授权中消在线网收集您的下列信息（收集范围）：
        <br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1.1.1 您的身份信息，包括但不限于姓名/用户名、证件号码、证件类型、住所地、电话号码、相关账户认证信息、电子邮箱地址、银行账户及其他支付工具的账户信息、生物特征信息以及其他相关附加信息；
        <br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1.1.2 您访问中消在线网站及其相关网站、移动设备客户端时，或使用中消在线平台服务时的操作日志，包括但不限于您的计算机IP地址、设备标识符、硬件型号、操作系统版本、浏览器的类型、使用的语言、访问日期和时间、网页记录、您的位置以及与中消在线平台服务相关的日志信息；
        <br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1.1.3 您在申请、使用中消在线平台服务时所提供及所形成的任何信息和数据；
        <br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1.1.4 您在中消在线平台留存的和形成的任何信息和数据（包括但不限于您的支付账户、证券账户、银行账户信息、任何声明及您在该等声明项下的履约情况、行为数据等）；
        <br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1.1.5 通过中国人民银行个人信用信息基础数据库及依法设立的信息服务机构或其他依法设立的征信机构获取您的相关信用信息和数据，包括但不限于任何征信记录、信用分、信用报告、能够联系到您的实体地址、电子邮件地址、电话号码等。
        <br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1.1.6 您的财产信息，包括但不限于您的企业经营状况、财税信息、房产信息、车辆信息、基金、保险、股票、信托、债券、P2P等投资理财信息和负债、担保信息；
        <br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1.1.7 您在行政机关、司法机关留存的任何信息，包括但不限于户籍信息/工商信息、诉讼信息、执行信息和违法犯罪信息等；
        <br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1.1.8 您在其他合法留存您信息的自然人、法人以及其他组织处留存的信息；
        <br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1.1.9 与您申请或使用的中消在线平台服务相关的、您留存的其他自然人、法人和其他组织的其他相关信息。
        <br/>&nbsp;&nbsp;&nbsp;1.2 您同意并授权中消在线网通过以下途径获取您的信息（收集方式）：
        <br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1.2.1 中消在线网为您提供相应服务页面，您可在页面自行输入您的相应信息（包含而不限于身份信息、教育信息、手机通讯录、通话记录、联系人信息、车辆信息、驾照信息、出行信息、消费信息和消费行为、银行账单、工作信息、公积金缴存信息、社交信息等）。
        <br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1.2.2 中消在线网通过1.2.1所述的方式获取您的信息时，不会保存您的账户和密码信息，该等信息和数据的获取是一次性的，除非得到您的再次授权，否则中消在线网不会以您的名义发起登陆而采集您的信息。
        <br/>&nbsp;&nbsp;&nbsp;1.3 您拒绝提供信息的后果
        <br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;如您拒绝提供中消在线网服务所需要的信息，将影响到中消在线网向您提供正常服务。包括但不限于无法登陆平台，无法进行实名认证，无法进行开店、无法推送信息并及时联系用户、无法进行交易和其他需要相应信息支持的服务。

        <br/><br/>2、信息保护和存储
        <br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;为保障您的信息安全，中消在线网采取各种合理的物理、电子和管理方面的安全措施来保护您的信息，使您的信息不会被泄漏、毁损或者丢失，包括但不限于SSL、信息加密存储、数据中心的访问控制、专用的网络通道及代理。中消在线网对可能接触到您的信息的员工或外包人员也采取了严格管理，包括但不限于根据岗位的不同采取不同的权限控制，与他们签署保密声明，监控他们的操作情况等措施。
        <br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;中消在线网会按现有技术提供相应的安全措施来保护您的信息，提供合理的安全保障，中消在线网将在任何时候尽力做到使您的信息不被泄漏、毁损或丢失。
        <br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;您的信息存储于中国的服务器上，为了安全及备份的需要，中消在线网可能将您的信息和资料储存到中消在线网旗下具备相应安全措施的公司的服务器上。
        <br/><br/>3、信息的使用
        <br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;为了更好地为您提供服务，也为了中消在线网自身的风险防控，您同意并授权中消在线网将您的信息用于如下用途：
        <br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3.1 创建数据分析模型，为您提供适合于您的服务，并维护、改进这些服务；
        <br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3.2 比较信息的准确性并与第三方进行验证；例如，将您向中消在线网提交的信息与合法提供信息验证的服务机构进行验证。
        <br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3.3 为使您知晓并了解中消在线平台服务情况，向您发送服务状态的通知及其他商业性电子信息；
        <br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3.4 记录并管理您访问和接受服务的状态、交易信息和历史记录；
        <br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3.5 预防、发现、调查欺诈、危害安全、非法或违反与中消在线平台规则的行为，以保护您、中消在线平台的其他用户及中消在线网的合法权益。
        <br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3.6 中消在线网可能会将来自某项服务的个人信息与来自其他服务所获得的信息结合起来，以便为您提供更加个性化的服务。
        <br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3.7 中消在线网会对中消在线平台服务使用情况进行统计，并可能会与公众或第三方分享这些统计信息，以展示中消在线平台的产品或服务的整体使用趋势，但这些统计信息不会包含您的任何身份识别信息，且该等信息将不会被复原。
        <br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3.8 让您参与有关中消在线平台服务的调查。
        <br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3.9 根据法律法规或经您同意或授权的其他用途。 
        <br/><br/>4、信息的分享
        <br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;您同意并授权中消在线网在下列情况下将您的信息与第三方共享：
        <br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;4.1 为了向您提供或推荐中消在线网关联公司的服务和/或产品的需要，将您的信息提供给中消在线网关联公司使用，且您同意中消在线网关联公司通过电子邮件、站内信、手机短信和传真等方式向您发送服务状态的通知、营销活动及其他商业性电子信息；
        <br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;4.2 某些服务和/或产品和/或推广活动由中消在线网、中消在线网关联公司的合作伙伴提供或由中消在线网、中消在线网关联公司与合作伙伴共同提供，中消在线网会与其共享并使用；
        <br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;4.3 在您违反有关法律法规、本声明、您与中消在线网签署相关声明时，向您的交易对手、中消在线网及中消在线网关联公司的合作伙伴等第三方提供，包括但不限于用于催收、诉讼等；
        <br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;4.4 为建立信用体系，向中国人民银行个人信用信息基础数据库及信息服务机构或其他依法设立的征信机构发送您的信用信息和数据，且不再另行通知您；
        <br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;4.5 只有共享您的信息，才能提供您需要的服务，或处理您与他人的纠纷或争议；
        <br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;4.6 为维护中消在线网和/或其他中消在线平台用户的合法权益；
        <br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;4.7 为遵守适用的法律法规、法院裁定或其他法律程序的规定、相关政府机关的要求。 
        <br/><br/>5、信息保密
        <br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;中消在线网将根据法律法规规定对您的个人信息予以保密，但下列情形除外：
        <br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;5.1 法律、法规、规章及其他规范性文件另有规定；
        <br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;5.2 政府机关、司法机关及监管部门提出要求；
        <br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;5.3 相关信息已成为公开信息；
        <br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;5.4 您同意无须再严格保密；
        <br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;5.5 本声明另有约定；
        <br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;5.6 其他合法情形。
        <br/><br/>6、信息的查询、更新、删除（部分） ：
        <br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;你可以查询、更新、删除（部分）您的个人信息。平台为您提供个人信息自助查询、更新、删除（部分）信息的功能，部分信息的删除功能需要您通过注销账号实现。同时您也可通过中消在线平台官方客服热线在核实和确认身份后要求中消在线平台客服提供相关信息的查询、更新、删除服务。
        <br/><br/>7、未成年人隐私权特别约定
        <br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;中消在线网重视未成年人的个人信息保护，如您为未成年人，建议您请您的监护人仔细阅读本政策，并在征得您的监护人同意的前提下使用中消在线平台服务或向中消在线网提供信息。 
        <br/><br/>8、修订
        <br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;中消在线网可能随时会对本政策进行变更，如发生变更，中消在线网将依据《中消在线平台服务协议》中有关通知事项的约定方式通知您，该变更将在公示后即时生效。若您在本政策变更后继续访问中消在线网的网站及其相关网站、或移动设备客户端，或使用中消在线网提供的任一服务，您确认这代表您已充分阅读、理解并接受修改后的本政策并受之约束。
        <br/><br/>9、效力和适用
        <br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;您应认真阅读并充分理解本隐私保护政策所有内容（特别是加粗字体内容）的意义以及由此产生的法律效力，自愿同意本政策。一旦您在线点击“同意”本隐私保护政策即视为该等行为是您本人真实的意思表示，您同意承担由此带来的一切法律后果。
        <br/><br/>10.法律管辖
        <br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;因您与中消在线网基于本政策的相关服务而产生争议，双方一致同意提交上海仲裁委员会按照其仲裁规则进行裁决。
        <br/>
        <br/>
    </div>
</template>

<script>
    export default {
        name: "privacy"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/view/app/privacy.vue